import { Injectable } from '@angular/core';
import {
  BaseService,
  HttpClient,
  HttpHeaders,
  HttpParams,
} from './base.service';
import { IShiftTemplateItem } from '../shared/api';
import { AccountService } from './account.service';

@Injectable()
export class ShiftTemplateItemService extends BaseService<IShiftTemplateItem> {
  constructor(accountService: AccountService, http: HttpClient) {
    super(accountService, http, 'shiftTemplateItem');
  }

  postProcess(): (data: any) => any {
    return data => {
      if (Array.isArray(data)) {
        for (let d of data) {
          this.fixDate(d, 'start');
          this.fixDate(d, 'end');
        }
      } else {
        this.fixDate(data, 'start');
        this.fixDate(data, 'end');
      }
      return data;
    };
  }
}

export { IShiftTemplateItem } from '../shared/api';
